import { useIntl } from "react-intl";

import messages from "../locales/messages";
const useTranslation = () => {
  const t = useIntl().formatMessage;
  const m = messages;

  return {
    t,
    m,
  };
};

export default useTranslation;
